import { canonicalPiProviderId } from "@rakazo/contracts";
import type { ModelCatalogEntry } from "../../lib/model-auth";

/**
 * The name the catalog gives a provider. A model id the catalog does not list (a custom
 * OpenAI-compatible model) still belongs to a listed provider, so the name comes from the
 * provider, not the model. Falls back to the raw id only for a provider the catalog lacks.
 */
export function providerDisplayName(
  catalog: readonly ModelCatalogEntry[],
  provider: string,
): string {
  const id = canonicalPiProviderId(provider);
  return (
    catalog.find((entry) => canonicalPiProviderId(entry.provider) === id)?.providerName ?? provider
  );
}
